import _ from "lodash";
import moment from "moment";
import ObservableModel from "util/ObservableModel";

/**
 * Represents the wrapup data associated with a communication.
 */
export default ObservableModel.extend(
    {
        defaults: {
            startTime: null,
            code: null,
            notes: "",
            tags: [],
            durationSeconds: null,
            endTime: null,
            availableCodes: [],
        },
    },
    function () {
        const self = this;

        self.unwrap = function () {
            const data = ObservableModel.unwrap(self, [
                "id",
                "startTime",
                "errors",
                "isAnyMessageShown",
                "isValid",
                "unwrap",
                "availableCodes",
            ]);

            data.endTime = moment().toISOString();
            data.tags = _.map(self.tags(), "label");

            return data;
        };
    }
);
